import { Suspense, lazy, useState } from 'react';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { Button } from 'components/FormComponents';

export const RenewalResultsModal = ({
  result,
  visible,
  onStatusChange = () => {},
  onClose = () => {},
}) => {
  const PDFPreview = lazy(() => import('components/FilePreview/PDFPreview'));

  const [loading, setLoading] = useState(true);

  const onLoadSuccess = ({ numPages }) => {
    setLoading(false);
  };

  const handleStatusChange = status => {
    onStatusChange(result?.candidate_check_id, status);
  };

  const open = e => {
    e.preventDefault();
    e.stopPropagation();
    window.open(result.upload_url, '_blank');
  };

  return (
    <AnimatedModal visible={visible} onClose={onClose} title={result?.candidate_name}>
      <div className="position-relative u-card u-padding background-secondary card-with-border u-border-radius">
        {result && (
          <Suspense fallback={<div>Loading PDF viewer...</div>}>
            <PDFPreview
              url={result.upload_url}
              onLoadSuccess={onLoadSuccess}
              pageNumber={1}
              setIsLoading={setLoading}
              onClick={open}
            />
          </Suspense>
        )}
      </div>
      {result?.upload_url && (
        <div className="d-flex justify-content-between u-margin-top">
          <Button onClick={onClose} type="secondary" small>
            Cancel
          </Button>
          <div className="d-flex">
            <Button
              onClick={() => handleStatusChange('not_approved')}
              className="u-margin-right--small"
              type="delete"
              small>
              Reject
            </Button>
            <Button onClick={() => handleStatusChange('approved')} type="success" small>
              Approved
            </Button>
          </div>
        </div>
      )}
    </AnimatedModal>
  );
};
